module.exports = __webpack_public_path__ + "static/img/wechat.28725df0.svg";